import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["tabActive", "tabInactive"]
  static values = { index: Number }

  connect() {
    this.show(this.indexValue || 0)
  }

  select({ currentTarget }) {
    this.show(this.tabTargets.indexOf(currentTarget))
  }

  show(index) {
    this.indexValue = index

    this.tabTargets.forEach((tab, i) => {
      const isActive = i === index
      
      // Remove all classes first
      if (this.hasTabActiveClass) {
        this.tabActiveClasses.forEach(cls => tab.classList.remove(cls))
      }
      if (this.hasTabInactiveClass) {
        this.tabInactiveClasses.forEach(cls => tab.classList.remove(cls))
      }
      
      // Add appropriate classes
      if (isActive && this.hasTabActiveClass) {
        this.tabActiveClasses.forEach(cls => tab.classList.add(cls))
      } else if (!isActive && this.hasTabInactiveClass) {
        this.tabInactiveClasses.forEach(cls => tab.classList.add(cls))
      }
      
      tab.setAttribute("aria-selected", isActive)
    })

    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index
    })
  }
}
